
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Image_gallery","data-name":"Image gallery","xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"id":"Rectangle_15302","data-name":"Rectangle 15302","width":"30","height":"30","fill":"none"}}),_c('g',{attrs:{"id":"Group_45504","data-name":"Group 45504"}},[_c('g',{attrs:{"id":"Group_45506","data-name":"Group 45506"}},[_c('path',{attrs:{"id":"Path_32711","data-name":"Path 32711","d":"M23.25 23.25H6.75A2.253 2.253 0 014.5 21V9a2.253 2.253 0 012.25-2.25h16.5A2.253 2.253 0 0125.5 9v12a2.253 2.253 0 01-2.25 2.25M6 19.061V21a.752.752 0 00.75.75h16.5A.752.752 0 0024 21v-1.939l-2.689-2.689a1.538 1.538 0 00-2.122 0l-.878.878.969.97a.75.75 0 01-1.06 1.06l-5.159-5.158a1.538 1.538 0 00-2.122 0zm14.25-4.628a2.978 2.978 0 012.121.879L24 16.939V9a.752.752 0 00-.75-.75H6.75A.752.752 0 006 9v7.939l3.879-3.877a3.072 3.072 0 014.242 0l3.129 3.127.879-.877a2.978 2.978 0 012.121-.879m-3-2.058a1.125 1.125 0 111.125-1.125 1.125 1.125 0 01-1.125 1.125"}})])])])
          )
        }
      }
    